<template>
	<div class="IndustryServiceWarp">
		<NavMenu/>
		<el-image :src="img1" class="topimgbox"></el-image>
		<div class="typeArae">
			<div class="primaryTitle">
				<span class="left-line"></span>
				<span class="title">团标建设</span>
				<span class="right-line"></span>
			</div>
			<div class="boxwarp1">
				<div class="rightMore" @click="gonewsecond1">
					<span class="morebox">
						更多
						<i class="el-icon-caret-right"></i>
					</span>
				</div>
				<div class="newBox1" v-if="testDataList.length!=0">
					<div class="leftinfobox" @click="goNewsDetailFn(testDataList[0])">
						<div class="textBox">
							<div class="title overflowone">{{testDataList[0].pressTopic}}</div>
							<div class="time">{{testDataList[0].pressTime | timer}}</div>
							<div class="synopsis overflowthree">{{testDataList[0].synopsis}}</div>
							<div class="trianglebox">
							</div>
						</div>
						<img class="imgbox" :src="srcUrl+testDataList[0].titleImgUrl" />
					</div>
					<div class="centerbox" @click="goNewsDetailFn(testDataList[1])">
						<img class="imgbox" :src="srcUrl+testDataList[1].titleImgUrl" />
						<div class="textBox">
							<div class="trianglebox"> </div>
							<div class="title overflowone">{{testDataList[1].pressTopic}}</div>
							<div class="time">{{testDataList[1].pressTime | timer}}</div>
							<div class="synopsis overflowthree">{{testDataList[1].synopsis}}</div>

						</div>
					</div>
					<div class="rightbox" @click="goNewsDetailFn(testDataList[2])">
						<div class="textBox">
							<div class="title overflowone">{{testDataList[2].pressTopic}}</div>
							<div class="time">{{testDataList[2].pressTime | timer}}</div>
							<div class="synopsis overflowthree">{{testDataList[2].synopsis}}</div>
							<div class="trianglebox">
							</div>
						</div>
						<img class="imgbox" :src="srcUrl+testDataList[2].titleImgUrl" />
					</div>
				</div>
				<div class="emptyBox" v-else>
					<img src="@/assets/imgs/home/emptyimg.png" />
					
				</div>

			</div>
			<div class="primaryTitle">
				<span class="left-line"></span>
				<span class="title">标准动态</span>
				<span class="right-line"></span>
			</div>
			<div class="newBox2">
				<div class="rightMore" @click="gonewsecond2">
					<span class="morebox">
						更多
						<i class="el-icon-caret-right"></i>
					</span>
				</div>
				<div class="topImgbot4textBox">
					<div v-for="(item,index) in newsDataBox2" :key="index" class="newsItembox" @click="goNewsDetailFn(item)">
						<img :src="srcUrl+item.titleImgUrl" class="imgbox" />
						<div class="contentbox">
							<div class="title overflowone">{{item.pressTopic}}</div>
							<div class="synopsis overflowtwo">{{item.synopsis}}</div>
							<div class="time">{{item.pressTime | timer}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="newBox3">
			<div class="newBoxwarp">
				<div class="TitleBox">
					<span class="leftline"></span>
					<span class="title">调查研究</span>
					<span class="rightline"></span>
				</div>
				<div  v-if="newsDataBox3.length!==0">
					<div class="newstextBox">
						<div v-for="(item,index) in newsDataBox3" :key="index" class="infoitembox" @click="goNewsDetailFn(item)">
						</div>
					</div>
					<div class="handlebox" @click="gonewsecond3">
						查看更多
					</div>
				</div>
				<div class="emptyBox" v-else>
					<img src="@/assets/imgs/home/emptyimg.png" />
					
				</div>

			</div>
		</div>
		<div class="typeArae">

			<div class="primaryTitle">
				<span class="left-line"></span>
				<span class="title">专家库</span>
				<span class="right-line"></span>
			</div>
			<div class="newBox4" v-if="newsDataBox4.length!==0">
				<!-- <img class="leftImg" :src="left" alt="" @click="lastNewFn(index)" />
            <img class="rightImg"  :src="right" alt="" @click="nextNewFn(index)" /> -->
				<div v-for="(item, index) in newsDataBox4" :key="index" class="imgtextbox" v-show="currentChangeindex == index">
					<img class="leftImg" :src="left" alt="" @click="lastNewFn(index)" />
					<img :src="srcUrl+item.titleImgUrl" class="imgBox" alt="" />
					<img class="rightImg" :src="right" alt="" @click="nextNewFn(index)" />
					<div class="rightbox" @click="goNewsDetailFn(item)">
						<div class="righttop">
							<div class="title overflowone">{{item.pressTopic}}</div>
							<div class="more" @click="gonewsecond4">
								更多
								<!-- <i class="el-icon-caret-right"></i> -->
							</div>
						</div>
						<div class="synopsis overflowthree">{{item.synopsis}}</div>
						<div class="detailbtn">查看详情</div>
					</div>
				</div>
				<!-- <div class="leftimgbox">
                <div class="projectCase">
                    <div class="contBox" ref="contBox">
                        <div class="contItem" v-for="(item, index) in testDataList" @mouseover="over" @mouseleave="leave" :key="index">
                            <div class="imgBox1">
                                {{index}}
                                <img :src="srcUrl+item.titleImgUrl" alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                <img @click="leftChange" class="leftImg" :src="left" alt="" @mouseover="over" @mouseleave="leave" />

                <img class="rightImg" @click="rightChange" :src="right" alt="" @mouseover="over" @mouseleave="leave" />
            </div> -->
				<!-- <div class="rightbox">内容</div> -->
			</div>
			<div class="emptyBox" v-else>
				<img src="@/assets/imgs/home/emptyimg.png" />
				
			</div>
		</div>
		<Footer/>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
		NavMenu,
		Footer
	},
	data() {
		return {
			img1: require("@/assets/imgs/news/img3.png"),
			srcUrl: srcUrl,
			left: require("@/assets/imgs/news/lefticon.png"),
			right: require("@/assets/imgs/news/righticon.png"),
			testDataList: [],
			newsDataBox2: [],
			newsDataBox3: [],
			newsDataBox4: [],
			// 专家库
			currentChangeindex: 0,
		}
	},
	mounted() {
		this.getTest()
		this.getnews()
		this.getnews2()
		this.getnews3()

	},
	methods: {
		async getTest() {
			let params = {
				pageSize: 3,
				pageCurrent: 1,
				pressSuperClass: 26,
				audit:1,
                status:1
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.testDataList = data.result.list
			}
		},
		async getnews() {
			let params = {
				pageSize: 4,
				pageCurrent: 1,
				pressSuperClass: 11,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsDataBox2 = data.result.list
			}
		},
		async getnews2() {
			let params = {
				pageSize: 3,
				pageCurrent: 1,
				pressSuperClass: 27,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsDataBox3 = data.result.list
			}
		},
		async getnews3() {
			let params = {
				pageSize: 4,
				pageCurrent: 1,
				pressSuperClass: 28,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsDataBox4 = data.result.list
			}
		},
		// 专家库
		lastNewFn(index) {
			if (index == 0) {
				this.$message({
					message: "当前新闻是第一条哦",
					type: "warning",
				});
			} else {
				this.currentChangeindex = index - 1;
			}
		},
		nextNewFn(index) {
			if (index == this.newsDataBox3.length - 1) {
				this.$message({
					message: "已经是最后一条了",
					type: "warning",
				});
			} else {
				this.currentChangeindex = index + 1;
			}
		},
		leftChange() {
			let contBox = this.$refs.contBox;
			let number = contBox.style.transform

				? contBox.style.transform.split("(")[1].split("p")[0] * 1
				: 0;
			if (number < 0) {
				contBox.style.transform = `translateX(${585 + number}px)`;
				this.right = require("@/assets/imgs/news/righticon.png");
			}
			if (number >= -585) {
				this.left = require("@/assets/imgs/news/lefticon.png");
			}
		},
		rightChange() {
			let contBox = this.$refs.contBox;
			contBox.style.transition = "all 1.5s linear";
			let number = contBox.style.transform

				? contBox.style.transform.split("(")[1].split("p")[0] * 1
				: 0;
			// 目前只显示3个，超出就不能滑动了
			if (number > -1170) {
				contBox.style.transform = `translateX(${-585 + number}px)`;
				this.left = require("@/assets/imgs/news/lefticon.png");
			}
			if (number == -1170) {
				this.right = require("@/assets/imgs/news/righticon.png");
			}
		},

		over() {
			window.clearInterval(this.timer);
		},

		leave() {
			this.setTimer();
		},
		// 移动定时器
		setTimer() {
			this.timer = setInterval(() => {
				let contBox = this.$refs.contBox;

				if (contBox) {
					let number = contBox.style.transform
						? contBox.style.transform.split("(")[1].split("p")[0] * 1
						: 0;
					this.rightChange();
					if (number <= -1170) {
						setTimeout(() => {
							contBox.style.transform = `translateX(${0}px)`;
							contBox.style.transition = "all 1s";
							this.left = require("@/assets/imgs/news/lefticon.png");
							this.right = require("@/assets/imgs/news/righticon.png");
						}, 0);
					}
				}
			}, 3500);
		},
		gonewsecond1() {
			this.$router.push('/industry-secondpage/mark-build');
		},
		gonewsecond2() {
			this.$router.push('/industry-secondpage/standard-dynamic');
		},
		gonewsecond3() {
			this.$router.push('/industry-secondpage/investigate');
		},
		gonewsecond4() {
			this.$router.push('/industry-secondpage/experts-think');
		},
		goNewsDetailFn(val) {
			this.$router.push({
				path: "/news-detail",
				query: {
					id: val.pressId,
				},
			});
		}

	},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		},
	},
}
</script>
<style lang="less" scoped>
.IndustryServiceWarp {
	.topimgbox {
		width: 100%;
		height: 300px;
	}
	.boxwarp1 {
		width: 1200px;
		margin: 0 auto;
	}
	.newBox1 {
		width: 1200px;
		min-height: 548px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		.textBox {
			padding: 53px 24px;
			box-sizing: border-box;
			height: 274px;
			position: relative;
			.title {
				font-size: 18px;
				font-weight: bold;
				line-height: 28px;
				color: #448df7;
			}
			.time {
				color: #999999;
				line-height: 36px;
				margin-bottom: 20px;
			}
			.synopsis {
				font-size: 16px;
				font-weight: 400;
				line-height: 30px;
				color: #666666;
			}
		}
		.imgbox {
			width: 432px;
			height: 274px;
		}
		.leftinfobox,
		.centerbox,
		.rightbox {
			display: flex;
			flex-direction: column;
			width: 432px;
			cursor: pointer;
		}
		.leftinfobox,
		.rightbox {
			.trianglebox {
				width: 0px;
				height: 0px;
				border-right: 40px solid transparent;
				border-left: 40px solid transparent;
				border-top: 40px solid #fff;
				position: absolute;
				bottom: -40px;
				left: 50%;
				transform: translateX(-50%);
			}
		}
		.centerbox {
			margin: 0 20px;
			.trianglebox {
				width: 0px;
				height: 0px;
				border-right: 40px solid transparent;
				border-left: 40px solid transparent;
				border-bottom: 40px solid #fff;
				position: absolute;
				top: -40px;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}
	.newBox2 {
		width: 1200px;
		margin: 0 auto;
		.newsItembox {
			cursor: pointer;
		}
	}
	.newBox3 {
		width: 100%;
		height: 583px;
		background: url(../assets/imgs/news/img1.png) no-repeat 100% 100% ;
		margin: 40px auto 60px auto;
		.newBoxwarp {
			width: 1200px;
			margin: 0 auto;
			.TitleBox {
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				padding-top: 30px;
				position: relative;
				.leftline,
				.rightline {
					display: inline-block;
					width: 120px;
					height: 1px;
					background: rgba(255, 255, 255, 0.5882352941176471);
				}
				.title {
					font-size: 30px;
					font-weight: bold;
					line-height: 47px;
					color: #ffffff;
					margin: 0 26px;
				}
				.title::before {
					content: '';
					position: absolute;
					width: 68px;
					height: 0px;
					border: 2px solid #448df7;
					opacity: 1;
					background: #448df7;
					left: 50%;
					transform: translateX(-50%);
					bottom: -5px;
				}
			}
			.newstextBox {
				display: flex;
				justify-content: center;
				margin: 50px 0 40px 0;
				.infoitembox {
					width: 418px;
					height: 298px;
					background-color: rgba(68, 141, 247, 0.39);
					box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.08);
					// background-image: url(../assets/imgs/news/img2.png) no-repeat;
					background: url(../assets/imgs/news/img2.png) no-repeat rgba(68, 141, 247, 1);
					background-position: 10% 10%;
					margin-top: 30px;
					&:nth-child(2) {
						// position: absolute;
						margin-top: 0;
						width: 418px;
						z-index: 99;
					}
				}
			}
			.handlebox {
				width: 150px;
				margin: 0 auto;
				height: 45px;
				border: 1px solid #ffffff;
				font-size: 16px;
				line-height: 45px;
				color: #ffffff;
				text-align: center;
				cursor: pointer;
				&:hover {
					border: 1px solid rgba(68, 141, 247, 1);
					color: #448df7;
				}
			}
		}
	}
	.newBox4 {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		overflow: hidden;
		position: relative;
		.leftImg {
			position: absolute;
			width: 58px;
			height: 58px;
			top: 116px;
			left: 0px;
			cursor: pointer;
		}
		.rightImg {
			position: absolute;
			width: 58px;
			height: 58px;
			top: 116px;
			left: 730px;
			cursor: pointer;
		}
		.imgtextbox {
			width: 1200px;

			display: flex;
			flex-direction: row;
			.imgBox {
				width: 586px;
				height: 320px;
				margin: 0 100px;
			}
			.rightbox {
				width: 600px;
				.righttop {
					display: flex;
					align-items: center;
					// justify-content: space-between;
					margin-bottom: 20px;
					.title {
						font-size: 18px;
						font-weight: bold;
						line-height: 28px;
						color: #333333;
						width: 62%;
					}
					.more {
						font-size: 16px;
						line-height: 36px;
						color: #cacaca;
						cursor: pointer;
						width: 20%;
						text-align: right;
					}
				}
				.synopsis {
					margin-bottom: 50px;
					font-size: 16px;
					line-height: 30px;
					color: #666666;
				}
				.detailbtn {
					border: 1px solid #999999;
					line-height: 36px;
					color: #999999;
					width: 150px;
					text-align: center;
					cursor: pointer;
				}
			}
		}
		.leftimgbox {
			width: 780px;
			display: flex;
			justify-content: center;
			position: relative;
			.projectCase {
				width: 585px;
				height: 320px;
				overflow: hidden;

				.contBox {
					width: 2000px;
					height: 320px;
					transition: all 1.5s linear;
				}
				.contItem {
					width: 585px;
					height: 320px;
					float: left;
				}
				.contItem:hover {
					img {
						transform: scale(1.2);
						box-shadow: 0px 3px 10px #cee2f1;
					}
				}
				.projectText {
					font-size: 16px;
					line-height: 30px;
					color: #333333;
					opacity: 1;
					text-align: center;
				}
				.imgBox1 {
					width: 586px;
					height: 320px;
					overflow: hidden;
					background: red;
				}

				img {
					width: 100%;
					transition: all 1s;
				}
			}
			.leftImg {
				position: absolute;
				left: 0px;
				top: 116px;
				cursor: pointer;
				width: 58px;
				height: 58px;
			}
			.rightImg {
				position: absolute;
				right: 0px;
				top: 116px;
				cursor: pointer;
				width: 58px;
				height: 58px;
			}
		}
		.rightbox {
			margin-left: 60px;
		}
	}
	.footer-warp {
		margin-top: 60px;
	}
}
</style>


